import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface AdditionalPageProps {
    height?: string;
    width?: string;
    viewBox?: string;
}

const AdditionalPage: React.FunctionComponent<React.PropsWithChildren<AdditionalPageProps>> = ({
    height,
    width,
    ...rest
}): any => (
    <SVGBase viewBox="0 0 500 500" height={height} width={width} title={'Additional Page'} {...rest}>
        <path
            d="m18.46 449.11h463.08a18.47 18.47 0 0 0 18.46-18.46v-273.65l-112.85-106.11h-368.69a18.47 18.47 0 0 0 -18.46 18.46v361.3a18.47 18.47 0 0 0 18.46 18.46z"
            fill="#ccefff"
        />
        <rect fill="#fff" height="138.09" rx="11.54" width="427.06" x="37.06" y="117.18" />
        <path
            d="m464.12 150.29v-4h-45.26v-29.11h-4v29.15h-51.22v-33.21h-4v33.21h-51.21v-29.15h-4v29.15h-51.22v-32.09h-4v32.09h-51.21v-29.15h-4v29.15h-51.23v-33.21h-4v33.21h-101.71v4h101.76v33.1h-101.76v4h101.76v33.1h-101.76v4h101.76v34.76h4v-34.88h51.18v34.76h4v-34.76h51.26v35.88h4v-35.88h51.26v34.76h4v-34.76h51.25v34.76h4v-34.76h51.13v34.76h4v-34.76h45.26v-4h-45.3v-33.1h45.26v-4h-45.26v-33.1zm-104.44 0v33.1h-51.25v-33.1zm-55.21 0v33.1h-51.26v-33.1zm-55.22 0v33.1h-51.25v-33.1zm-106.48 0h51.23v33.1h-51.23zm0 70.16v-33.1h51.23v33.1zm55.22 0v-33.1h51.26v33.1zm55.22 0v-33.1h51.26v33.1zm55.22 0v-33.1h51.25v33.1zm106.47 0h-51.26v-33.1h51.26zm0-37.06h-51.26v-33.1h51.26z"
            fill="#ccefff"
        />
        <path
            d="m367.19 138.14a10.8 10.8 0 0 0 -10.45 11.14 10.64 10.64 0 0 0 1.42 5l-35.16 32.8a10.75 10.75 0 0 0 -13.86 3.35l-65.3-9.33a10.79 10.79 0 0 0 -21.26 1.6l-40.44 17.43a10.8 10.8 0 0 0 -19.14-1.54l-39.06-16.09a10.8 10.8 0 1 0 -20 1.81l-26.13 27.2a10.82 10.82 0 1 0 4.86 3.94l25.54-26.59a10.72 10.72 0 0 0 12.32-1.06l40.89 16.85a10.79 10.79 0 0 0 21.32 2l41.2-17.75a10.79 10.79 0 0 0 19.52-1.56l63.73 9.1v.52a10.8 10.8 0 1 0 21.58-.68 10.65 10.65 0 0 0 -1.32-4.83l35.29-32.86a10.8 10.8 0 1 0 4.51-20.45z"
            fill="#99e0ff"
        />
        <rect fill="#fff" height="137.59" rx="7.9" width="200.55" x="263.57" y="279.89" />
        <rect fill="#fff" height="137.59" rx="7.9" width="200.55" x="35.88" y="279.89" />
        <path
            d="m396.29 402.59 3.45-43.71-43.26 9.44a43.91 43.91 0 0 0 19.18 27.43 3 3 0 0 1 .3.18 43.93 43.93 0 0 0 20.33 6.66z"
            fill="#99e0ff"
        />
        <path d="m396.29 402.59a44 44 0 0 0 40.21-20.13l-36.76-23.58z" fill="#ccefff" />
        <path
            d="m390.29 315.61a43.82 43.82 0 0 0 -27.92 19.29 43.82 43.82 0 0 0 -5.89 33.41l43.25-9.44z"
            fill="#ccefff"
        />
        <path
            d="m423.51 321.82c-.1-.06-.19-.15-.3-.22a43.88 43.88 0 0 0 -32.91-6l9.44 43.26 36.75 23.58a44 44 0 0 0 -12.98-60.62z"
            fill="#99e0ff"
        />
        <circle cx="399.44" cy="358.66" fill="#fff" r="24.37" />
        <g fill="#99e0ff">
            <path d="m117.55 363.89h15.28a4.5 4.5 0 0 1 4.51 4.5v25.46a4.52 4.52 0 0 1 -4.53 4.52h-15.28a4.5 4.5 0 0 1 -4.5-4.5v-25.46a4.53 4.53 0 0 1 4.52-4.52z" />
            <path d="m154.16 345.06h15.28a4.49 4.49 0 0 1 4.5 4.5v44.29a4.53 4.53 0 0 1 -4.52 4.52h-15.28a4.5 4.5 0 0 1 -4.51-4.5v-44.29a4.54 4.54 0 0 1 4.53-4.52z" />
            <path d="m190.76 316.89h15.24a4.5 4.5 0 0 1 4.51 4.5v72.46a4.54 4.54 0 0 1 -4.53 4.52h-15.24a4.51 4.51 0 0 1 -4.5-4.5v-72.46a4.53 4.53 0 0 1 4.52-4.52z" />
            <path d="m387.44 50.89v89.76c0 9 7.78 16.38 17.37 16.38h95.19z" />
            <path d="m166.11 94.29h-122.01a6.24 6.24 0 0 1 0-12.48h122a6.24 6.24 0 0 1 0 12.48z" />
            <path d="m247.82 94.29h-54.42a6.24 6.24 0 0 1 0-12.48h54.42a6.24 6.24 0 1 1 0 12.48z" />
        </g>
        <path d="m124.7 309h-64.59a6.24 6.24 0 0 1 0-12.47h64.59a6.24 6.24 0 0 1 0 12.47z" fill="#bdeeff" />
        <path d="m109.39 332.61h-49.28a6.24 6.24 0 0 1 0-12.47h49.28a6.24 6.24 0 1 1 0 12.47z" fill="#bdeeff" />
        <path d="m346 309h-64.54a6.24 6.24 0 1 1 0-12.47h64.54a6.24 6.24 0 1 1 0 12.47z" fill="#bdeeff" />
        <path d="m330.74 332.61h-49.28a6.24 6.24 0 1 1 0-12.47h49.28a6.24 6.24 0 0 1 0 12.47z" fill="#bdeeff" />
    </SVGBase>
);

export default AdditionalPage;
